<template>
  <div>
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <div class="ba_f mar_t20 mar_b20">
        <div class="pagetitle mar_b20">{{ $t('set.notice.title') }}</div>
        <el-button type="primary" size="medium" @click="handleEdit(false,1)">{{ $t('set.notice.add') }}</el-button>
      </div>
      <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%" @selection-change="setSelectRows">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="sort" :label="$t('common.sort')"></el-table-column>
        <el-table-column prop="title" :label="$t('set.notice.noticeTitle')"></el-table-column>
        <el-table-column prop="createdAt" :label="$t('common.addTime')"></el-table-column>
        <el-table-column :label="$t('common.operation')">
          <template slot-scope="scope">
            <div class="flex">
              <el-button type="text" @click="handleEdit(scope.row.id)">{{ $t('common.view') }}</el-button>
              <el-button type="text" @click="handleDelete(scope.row)">{{ $t('common.delete') }}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="page.pagesize" :current-page.sync="page.currentPage" @current-change="handleCurrentChange"></el-pagination>
    </div>
    <notice-add-edit ref="dialogFormVisible" v-if="dialogFormVisible" @closeDia="dialogFormVisible = false" @refreshData="fetchData"></notice-add-edit>
  </div>
</template>
<script>
import { agreementList, deleteRule } from '@/api/set';
import NoticeAddEdit from './components/notice-add-edit.vue';
export default {
  components: { NoticeAddEdit },
  data() {
    return {
      listLoading: true,
      dialogFormVisible: false,
      form: {
        id: '',
        sort: '',
        title: '',
        body: ''
      },
      list: [],
      selectRows: '',
      page: {
        total: 0,
        size: 10,
        currentPage: 1
      }
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    loadingText() {
      return this.$t('common.loading');
    }
  },
  methods: {
    fetchData() {
      var params = {
        type: 1,
        page: this.page.currentPage
      };
      agreementList(params).then((res) => {
        if (res.code == 1) {
          this.list = res.data;
          this.page.total = res.count;
          this.listLoading = false;
        }
      });
    },
    setSelectRows(val) {
      this.selectRows = val;
    },
    handleEdit(id, type) {
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs.dialogFormVisible.init(id, type);
      });
    },
    handleDelete(row) {
      if (row.id) {
        this.$baseConfirm(this.$t('confirm.deleteItem'), null, async () => {
          const { msg } = await deleteRule({ id: row.id });
          this.$baseMessage(msg, 'success');
          this.fetchData();
        });
      }
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.fetchData();
    }
  }
};
</script>
